const ALLOWED_LIST_CHILD_TAGS = new Set(['LI', 'SCRIPT', 'TEMPLATE']);

const HEADING_RULES = [
  { level: 1, pattern: /END\s+USER\s+AGREEMENT/i },
  { level: 2, pattern: /WILLIAM O['']NEIL INDIA PRIVATE LIMITED/i },
  { level: 2, pattern: /^Standard warning and disclaimer$/i }
];

function normalizeWhitespace (text) {
  return (text || '').replace(/\s+/g, ' ').trim();
}

function replaceParagraphWithHeading (paragraph, level, doc) {
  const heading = doc.createElement(`h${level}`);
  heading.className = `legal-agreement-h${level}`;

  while (paragraph.firstChild) {
    heading.appendChild(paragraph.firstChild);
  }

  paragraph.parentNode.replaceChild(heading, paragraph);
}

function promoteLegalAgreementHeadings (root, doc) {
  root.querySelectorAll('p').forEach((paragraph) => {
    const text = normalizeWhitespace(paragraph.textContent);
    if (!text) {
      return;
    }

    const rule = HEADING_RULES.find(({ pattern }) => pattern.test(text));
    if (rule) {
      replaceParagraphWithHeading(paragraph, rule.level, doc);
    }
  });
}

/**
 * Wraps invalid direct children of ul/ol (e.g. Word-exported <p> tags) in <li>
 * and promotes known document titles to semantic headings for screen readers.
 */
export function fixLegalAgreementHtml (html) {
  if (!html || typeof html !== 'string') {
    return html || '';
  }

  if (typeof DOMParser === 'undefined') {
    return html;
  }

  const doc = new DOMParser().parseFromString(
    `<div id="legal-agreement-root">${html}</div>`,
    'text/html'
  );
  const root = doc.getElementById('legal-agreement-root');
  if (!root) {
    return html;
  }

  const lists = Array.from(root.querySelectorAll('ul, ol')).reverse();

  lists.forEach((list) => {
    Array.from(list.childNodes).forEach((child) => {
      if (child.nodeType === Node.TEXT_NODE) {
        const text = child.textContent.trim();
        if (!text) {
          list.removeChild(child);
          return;
        }
        const li = doc.createElement('li');
        li.textContent = text;
        list.replaceChild(li, child);
        return;
      }

      if (child.nodeType === Node.ELEMENT_NODE) {
        const tag = child.tagName.toUpperCase();
        if (!ALLOWED_LIST_CHILD_TAGS.has(tag)) {
          const li = doc.createElement('li');
          list.insertBefore(li, child);
          li.appendChild(child);
        }
      }
    });
  });

  promoteLegalAgreementHeadings(root, doc);

  return root.innerHTML;
}



// WEBPACK FOOTER //
// ./src/utils/fixLegalAgreementHtml.js